import React from 'react';
import { Link } from 'react-router-dom';
import { company } from '../../../data/site';

/** Logomærket på en lys flise + hvidt ordmærke, så det står klart på mørk baggrund. */
export function AdminLogo({
  compact = false
}: {
  compact?: boolean;
}) {
  return <Link to="/admin" className="flex items-center gap-2.5" aria-label="LYKKEVÆRK – Overblik" data-id="element-548" data-mp="30cfqsusl5u5f">
      <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-[#f4f1ea]" data-id="element-549" data-mp="35bixsks4mag1">
        <img src={company.logoMark} alt="" className="h-7 w-7 object-contain" data-id="element-550" data-mp="2coxzf0d8gy2z" />
      </span>
      {!compact && <span className="lv-wordmark text-[17px] tracking-[0.06em] text-ink" data-id="element-551" data-mp="2hoasw3ym13ej">LYKKEVÆRK</span>}
    </Link>;
}